<!--confirm弹窗-->
<script src="../../../../../../ssjj2-activity-fe/pc-mobile/src/router/index.js"></script>
<template>
  <ModalCommon ref="ModalCommon"
               :title="config.title">
    <div class="wrap">
      <div class="content">
        <div class="inner">
          <div class="package-content">
            <div class="package-content-left">
              <div class="package-content-scroll">
                <div class="package-content-item" v-for="item in packageList" :key="item.id">
                  <img :src="item.gift_icon" class="package-item-img" alt="">
                  <div class="package-item-btns" :style="{'background-image': `url(${item.status > 0 ? $MainWrap.packageInfo[0].btnGreySrc : $MainWrap.packageInfo[0].btnSrc})`}">
                    <div class="package-item-btn" @click="recivedFunc(item)">{{ getText(item.status, 'recive') }}</div>
                    <div class="package-item-btn" @click="decomposeFunc(item)">{{ getText(item.status) }}</div>
                  </div>
                </div>
              </div>
              <div class="package-content-pagecontroll" v-if="packageList.length">
                <div class="my-pagination-prev my-pagination-btn" @click="changePagination(-1)">上一页</div>
                <div class="my-pagination-total">{{ page }}/{{ Math.ceil(total / pageSize) }}</div>
                <div class="my-pagination-next my-pagination-btn" @click="changePagination(1)">下一页</div>
              </div>
            </div>
            <div class="package-content-right">
              <div class="package-right-title">
                <div>道具名称</div>
                <div>分解获得积分</div>
              </div>
              <div class="package-right-scroll">
                <div class="package-right-item" v-for="item in decomposeList" :key="item.id">
                  <div>{{ item.gift_name }}</div>
                  <div>{{ item.break_integral }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ModalCommon>

</template>

<script>
import ModalCommon from '../../_components/ModalCommon.vue'

export default {
  name: 'ModalConfirm',
  components: {
    ModalCommon
  },
  props: {
    title: {
      type: String,
      default: '恭喜获得'
    },
    btnText: {
      type: String,
      default: '开心收下'
    }
  },
  inject: {
    // 由 MainWrap 组件传入
    $MainWrap: {
      default: () => null
    }
  },
  data() {
    return {
      config: {
        title: '提示',
        content: '',
        confirmBtnText: '确定',
        cancelBtnText: '取消',
        onConfirm: () => {
        },
        onCancel: () => {
        }
      },
      packageList: [],
      decomposeList: [],
      total: 0,
      page: 1,
      pageSize: 10
    }
  },
  computed: {
    requestAPI() {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    modalConfirmBtnStyleObj() {
      try {
        return JSON.parse(this.$MainWrap.modalConfirmBtnStyle)
      } catch (e) {
        console.error('modalConfirmBtnStyle 格式错误')
        return {}
      }
    },
    modalCancelBtnStyleObj() {
      try {
        return JSON.parse(this.$MainWrap.modalCancelBtnStyle)
      } catch (e) {
        console.error('modalCancelBtnStyle 格式错误')
        return {}
      }
    }
  },
  async mounted() {
  },
  methods: {
    changePagination(num) {
      const page = this.page + num
      if (page < 1 || page > Math.ceil(this.total / this.pageSize)) {
        return
      }
      this.page = this.page + num
      this.queryList()
    },
    getText(status, type) {
      // 0 未处理 1已领取 2已分解
      let map = {
        0: type === 'recive' ? '领取' : '分解',
        1: type === 'recive' ? '已领取' : '分解',
        2: type === 'recive' ? '领取' : '已分解',
      }
      return map[status]
    },
    recivedFunc(item) {
      if (item.status) {
        return
      }
      this.requestAPI({
        url: '/v1/business/bag-receive',
        method: 'get',
        params: {
          id: item.id
        }
      }).then((data) => {
        this.$alert(`领取成功`, '提示', {
          confirmButtonText: '确定'
        })
        this.queryList()
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    decomposeFunc(item) {
      if (item.status) {
        return
      }
      this.$alert(`${item.gift_name}分解将获得积分10， 是否确认分解`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {
          console.log(action)
          if (action === 'confirm') {
            this.requestAPI({
              url: '/v1/business/bag-resolve',
              method: 'get',
              params: {
                id: item.id
              }
            }).then((data) => {
              this.$alert(`分解成功`, '提示', {
                confirmButtonText: '确定'
              })
              this.queryList()
              this.queryDecomposeList()
              this.$MainWrap.getMoneyFunc([this.$MainWrap.activityId4])
            }).catch((err) => {
              console.error(err)
              this.$message.error(err.msg || '系统错误')
            })
          }
        }
      })
    },
    queryList() {
      this.requestAPI({
        url: '/v1/business/bag-record',
        method: 'get',
        params: {a_id: this.$MainWrap.activityId3, page: this.page, page_size: this.pageSize}
      }).then((res) => {
        console.log(res, '--ag-record---')
        this.packageList = res.items || []
        this.total = res.total || 0
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    },
    queryDecomposeList() {
      this.requestAPI({
        url: '/v1/business/resolve-record',
        method: 'get',
        params: {a_id: this.$MainWrap.activityId3}
      }).then((res) => {
        console.log(res, '--ag-record---')
        this.decomposeList = res.items || []
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    },
    async open(options) {
      this.config = Object.assign({
        title: '提示',
        content: '',
        confirmBtnText: '确定',
        cancelBtnText: '取消',
        onConfirm: () => {
        },
        onCancel: () => {
        }
      }, options)
      this.queryList()
      this.queryDecomposeList()
      this.$refs.ModalCommon.open()
    },
    confirm() {
      this.config.onConfirm()
      this.close()
    },
    cancel() {
      this.config.onCancel()
      this.close()
    },
    close() {
      this.$refs.ModalCommon.close()
    }
  }
}
</script>

<style scoped lang="scss">
//@import "../common.scss";
.wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 40px;
}

.content {
  margin-bottom: 0;
  //height: 380px;
  //overflow-y: auto;
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  white-space: pre-wrap;

  .inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .package-content {
    display: flex;
    justify-content: space-between;
    height: 100%;

    .package-content-left {
      width: 50%;

      .package-item-btns {
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 157px;
        height: 46px;
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .package-item-btn {
          width: 50%;
          font-size: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .package-content-scroll {
        height: 80%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        overflow-y: auto;

        .package-item-img {
          width: 150px;
          height: 110px;
        }

        .package-content-item {
          margin-bottom: 20px;
        }
      }

      .package-content-pagecontroll {
        height: 20%;
        display: flex;
        margin: 0 auto;
        width: 200px;
        align-items: center;

        .my-pagination-total {
          margin: 0 10px;
        }
      }
    }

    .package-content-right {
      width: 50%;
      height: 100%;
      padding: 0 14px 14px 14px;

      .package-right-title, .package-right-item {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
          width: 50%;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .package-right-scroll {
        overflow-y: auto;
        height: calc(100% - 80px);
      }
    }
  }
}

.s-btn-wrap {
  padding: 30px 0 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.s-btn {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  width: 222px;
  height: 61px;
  line-height: 61px;
  color: #fff;
  margin: 0 20px;
  transition: .3s;
  cursor: pointer;
}

.s-btn-confirm {
  &:hover {
    filter: brightness(1.1);
  }
}
</style>
